import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

/**
 * Analytics — no-op unless REACT_APP_GA_MEASUREMENT_ID or REACT_APP_GOOGLE_ADS_ID is set.
 * Injects gtag.js once, fires a page_view on every route change.
 *
 * Also exposes helpers on window for one-off conversion tracking:
 *   window.trackConversion('form_submit') → sends event
 *   window.trackConversion('phone_click') → sends event
 *   window.trackConversion('quote_click') → sends event
 */
const Analytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Always expose a stub so components can call it without guard even when GA is off.
        // Real GA implementation below overrides this if a measurement ID is present.
        if (typeof window !== 'undefined' && !window.trackConversion) {
            window.trackConversion = () => {};
        }

        if (!GA_ID && !ADS_ID) return; // nothing configured

        if (!document.getElementById('ga4-loader')) {
            const s = document.createElement('script');
            s.id = 'ga4-loader';
            s.async = true;
            s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID || ADS_ID}`;
            document.head.appendChild(s);

            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
            window.gtag('js', new Date());
            if (GA_ID) window.gtag('config', GA_ID);
            if (ADS_ID) window.gtag('config', ADS_ID);

            // Helper for tracked events (form submits, phone clicks, quote clicks)
            window.trackConversion = (name, params = {}) => {
                if (window.gtag) window.gtag('event', name, params);
            };
        }
    }, []);

    // Fire page_view on route changes
    useEffect(() => {
        if (!GA_ID && !ADS_ID) return;
        if (window.gtag) {
            window.gtag('event', 'page_view', {
                page_path: location.pathname + location.search,
                page_location: window.location.href,
            });
        }
    }, [location]);

    return null;
};

export default Analytics;
